import Marionette from 'backbone.marionette';
import Navigator from 'app';
import journalController from './journal_controller';
var JournalRouter = Marionette.AppRouter.extend({
  appRoutes: {
    "journal": "showJournalHome"
  }
});
var API = {
  showJournalHome: function () {
    journalController.showJournalHome();
    // Navigator.updateAnalytics("journal");
  }
};

Navigator.vent.on("journal:home:show", function () {
  Navigator.navigate("journal");
  API.showJournalHome();
});
Navigator.on("before:start", function () {
  new JournalRouter({
    controller: API
  });
});
export { JournalRouter as default };